import { axiosGet } from '@/API/API';
import { INotification } from '@/pages/notifications/notification';

import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export type NotifResponse = {
	notifications: INotification[];
	unseenCount: number;
};

interface NotifState {
	notifs: NotifResponse | null;
	isFetchingNotifs: boolean;
}

const initialState: NotifState = {
	notifs: null,
	isFetchingNotifs: true,
};

export const fetchNotifs = createAsyncThunk('notif/fetchNotifs', async (page: number = 1) => {
	const res = await axiosGet<NotifResponse>(`api/notifications?limit=15&page=${page}`);
	return res?.data ?? null;
});

const notifSlice = createSlice({
	name: 'notif',
	initialState,
	reducers: {
		setNotifs: (state, action: PayloadAction<NotifResponse | null>) => {
			state.notifs = action.payload;
			state.isFetchingNotifs = false;
		},
		decrementUnseenCount: (state) => {
			if (state.notifs && state.notifs.unseenCount > 0) {
				state.notifs.unseenCount -= 1;
			}
		},
		markNotifAsSeen: (state, action: PayloadAction<number>) => {
			if (state.notifs?.notifications) {
				const notif = state.notifs.notifications.find((n) => n.id === action.payload);
				if (notif && !notif.isSeen) {
					notif.isSeen = true;
					if (state.notifs.unseenCount > 0) {
						state.notifs.unseenCount -= 1;
					}
				}
			}
		},
		markNotifAsClicked: (state, action: PayloadAction<number>) => {
			if (state.notifs?.notifications) {
				const notif = state.notifs.notifications.find((n) => n.id === action.payload);
				if (notif) {
					notif.isClicked = true;
				}
			}
		},
		setIsFetchingNotifs: (state, action: PayloadAction<boolean>) => {
			state.isFetchingNotifs = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchNotifs.fulfilled, (state, action) => {
			if (action.payload) {
				state.notifs = action.payload;
			}
			state.isFetchingNotifs = false;
		});
	},
});

export const { setNotifs, decrementUnseenCount, markNotifAsSeen, markNotifAsClicked, setIsFetchingNotifs } =
	notifSlice.actions;
export default notifSlice.reducer;
